import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const changeTestimonialStatusApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}testimonial/change-status`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default changeTestimonialStatusApi